import React from 'react';

import { Button } from '@flywire/headlessui-tailwindcss';

import { useTranslations } from 'utils';

type RedirectButtonProps = {
  url: string;
};

const RedirectButton = ({ url }: RedirectButtonProps) => {
  const i18n = useTranslations();

  return (
    <a href={url} data-testid="redirectButton">
      <Button tone="primary">{i18n.t('gatewayOnly.button')}</Button>
    </a>
  );
};

export { RedirectButton };
